"use client";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import HomeMaxIcon from "@mui/icons-material/HomeMax";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ShareIcon from "@mui/icons-material/Share";
import PermContactCalendarIcon from "@mui/icons-material/PermContactCalendar";
import React, { useEffect, useState } from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { Loader } from "../genericComponents/MainLoader/Loader";

const navLabelSx = {
  fontSize: "0.65rem",
  lineHeight: 1.2,
  display: "block" as const,
};

export const FooterNavigation = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [loading, setLoading] = useState(false);
  const [isLogin, setIsLogin] = useState<boolean>(false);
  const pathName = usePathname();

  useEffect(() => {
    const value = localStorage.getItem("isAlreadyLogin");
    setIsLogin(value === "true");
  }, []);

  const handleLoader = () => {
    setLoading(true);
  };
  const blankFunction = () => {};

  return (
    <>
      {isSmallScreen ? (
        <Box
          component="nav"
          aria-label="Primary"
          sx={{
            position: "fixed",
            bottom: "calc(6px + env(safe-area-inset-bottom, 0px))",
            left: "50%",
            transform: "translateX(-50%)",
            width: "calc(100% - 12px)",
            maxWidth: "430px",
            background:
              "linear-gradient(180deg, rgba(255,255,255,0.96) 0%, rgba(246,251,248,0.96) 100%)",
            backdropFilter: "blur(18px)",
            color: "#102117",
            padding: "6px 10px",
            textAlign: "center",
            zIndex: 1002,
            borderRadius: "22px",
            border: "1px solid rgba(18,53,36,0.08)",
            boxShadow: "0 18px 42px rgba(18,53,36,0.14)",
          }}
        >
          {loading && <Loader />}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              gap: "0.25rem",
            }}
          >
            <Box
              sx={{
                color: pathName == "/" ? "#1f7a4d" : "",
                width: "25%",
                display: "block",
                borderRadius: "14px",
                padding: "0.3rem 0.1rem",
                background: pathName == "/" ? "rgba(223,246,232,0.8)" : "transparent",
              }}
            >
              <Link
                prefetch={false}
                href={"/"}
                style={{ textDecoration: "none", color: "inherit" }}
                onClick={pathName !== "/" ? handleLoader : blankFunction}
              >
                <HomeMaxIcon sx={{ fontSize: "1.25rem" }} />
                <br />
                <Typography variant="caption" sx={navLabelSx}>
                  Home
                </Typography>
              </Link>
            </Box>
            <Box
              sx={{
                width: "25%",
                color: pathName == "/store" ? "#1f7a4d" : "",
                borderRadius: "14px",
                padding: "0.3rem 0.1rem",
                background:
                  pathName == "/store" ? "rgba(223,246,232,0.8)" : "transparent",
              }}
            >
              <Link
                prefetch={false}
                href={"/store"}
                style={{ textDecoration: "none", color: "inherit" }}
                onClick={pathName !== "/store" ? handleLoader : blankFunction}
              >
                <ShoppingBagIcon sx={{ fontSize: "1.25rem" }} />
                <br />
                <Typography variant="caption" sx={navLabelSx}>
                  Store
                </Typography>
              </Link>
            </Box>
            {isLogin ? (
              <Box
                sx={{
                  width: "25%",
                  color: pathName == "/appointments" ? "#1f7a4d" : "",
                  borderRadius: "14px",
                  padding: "0.3rem 0.1rem",
                  background:
                    pathName == "/appointments"
                      ? "rgba(223,246,232,0.8)"
                      : "transparent",
                }}
              >
                <Link
                  prefetch={false}
                  href={"/appointments"}
                  style={{ textDecoration: "none", color: "inherit" }}
                  onClick={
                    pathName !== "/appointments" ? handleLoader : blankFunction
                  }
                >
                  <CalendarMonthIcon sx={{ fontSize: "1.25rem" }} />
                  <br />
                  <Typography variant="caption" sx={navLabelSx}>
                    Bookings
                  </Typography>
                </Link>
              </Box>
            ) : (
              <Box
                sx={{
                  width: "25%",
                  color: pathName == "/contact" ? "#1f7a4d" : "",
                  borderRadius: "14px",
                  padding: "0.3rem 0.1rem",
                  background:
                    pathName == "/contact"
                      ? "rgba(223,246,232,0.8)"
                      : "transparent",
                }}
              >
                <Link
                  prefetch={false}
                  href={"/contact"}
                  style={{ textDecoration: "none", color: "inherit" }}
                  onClick={
                    pathName !== "/contact" ? handleLoader : blankFunction
                  }
                >
                  <PermContactCalendarIcon sx={{ fontSize: "1.25rem" }} />
                  <br />
                  <Typography variant="caption" sx={navLabelSx}>
                    Contact
                  </Typography>
                </Link>
              </Box>
            )}
            <Box
              sx={{
                width: "25%",
                color: pathName == "/refer&earn" ? "#1f7a4d" : "",
                borderRadius: "14px",
                padding: "0.3rem 0.1rem",
                background:
                  pathName == "/refer&earn"
                    ? "rgba(223,246,232,0.8)"
                    : "transparent",
              }}
            >
              <Link
                prefetch={false}
                href={"/refer&earn"}
                style={{ textDecoration: "none", color: "inherit" }}
                onClick={
                  pathName !== "/refer&earn" ? handleLoader : blankFunction
                }
              >
                <ShareIcon sx={{ fontSize: "1.25rem" }} />
                <br />
                <Typography variant="caption" sx={navLabelSx}>
                  Refer & Earn
                </Typography>
              </Link>
            </Box>
          </Box>
        </Box>
      ) : (
        ""
      )}
    </>
  );
};
